import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { Search } from 'react-feather';
import IconFeather from 'src/components/common/Icon';

const InputSearch = (props: TextFieldProps) => {
  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconFeather icon={<Search />} muiProps={{ fontSize: 'small', color: 'action' }} />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

export default InputSearch;
